"use client";
import { jsxs as o, jsx as e } from "react/jsx-runtime";
import g from "../../../layout/Container/Container.js";
import { Group as s, Heading as u, Paragraph as c, Link as _, Icon as f, Image as h } from "@ingeniorforeningen/figurine-core";
import { forwardRef as x } from "react";
import '../../../../assets/PageTopClassic.css';const w = "_root_1mz0y_2", y = "_image_1mz0y_6", z = "_teaser_1mz0y_14", a = {
  root: w,
  image: y,
  teaser: z
}, m = x((l, d) => {
  const { title: p, subtitle: t, teaser: i, image: n, editLink: r } = l;
  return /* @__PURE__ */ o(s, { ref: d, className: a.root, wrap: "nowrap", direction: "column", p: 0, children: [
    /* @__PURE__ */ o(s, { spacing: "md", align: "center", wrap: "nowrap", direction: "column", children: [
      /* @__PURE__ */ e(u, { type: "h1", text: p, align: "center" }),
      t && /* @__PURE__ */ e(c, { align: "center", text: t }),
      r && /* @__PURE__ */ e(_, { href: r, target: "_blank", children: /* @__PURE__ */ e(f, { name: "Edit", size: "xl" }) })
    ] }),
    i && /* @__PURE__ */ e(g, { children: /* @__PURE__ */ e(
      c,
      {
        text: i,
        align: "center",
        variant: "dark",
        medium: !0,
        className: a.teaser
      }
    ) }),
    n && /* @__PURE__ */ e(
      h,
      {
        ...n,
        caption: void 0,
        byline: void 0,
        orientation: "landscape",
        width: "100%",
        sizes: "(max-width: 62em) 95vw, 1140px",
        className: a.image
      }
    )
  ] });
});
m.displayName = "ClassicPageTop";
const T = m;
export {
  m as _PageTopClassic,
  T as default
};
